var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-6",
    transform: "translate(-703, -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(703, 407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFE1E3",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-clock-7016980",
    transform: "translate(11, 11)",
    fill: "#8B131C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,0 C6.05571429,0 0,6.05571429 0,13.5 C0,20.9442857 6.05571429,27 13.5,27 C20.9442857,27 27,20.9442857 27,13.5 C27,6.05571429 20.9442857,0 13.5,0 Z M21.0277778,16.4 L12.4722222,16.4 C11.7999804,16.4 11.25,15.8500196 11.25,15.1777778 L11.25,6.62222222 C11.25,5.94998044 11.7999804,5.4 12.4722222,5.4 C13.144464,5.4 13.6944444,5.94998044 13.6944444,6.62222222 L13.6944444,13.9555556 L21.0277778,13.9555556 C21.7000196,13.9555556 22.25,14.505536 22.25,15.1777778 C22.25,15.8500196 21.7000196,16.4 21.0277778,16.4 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconRed);
export default __webpack_public_path__ + "static/media/clock-icon--red.ea066432230d10b4b47f19642ff80cb2.svg";
export { ForwardRef as ReactComponent };